import React, { useCallback, useContext } from 'react';

import { CaseTeamsContext } from '../../case-teams.context';
import CaseTeamsForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(CaseTeamsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <CaseTeamsForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
